import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import agent from '@vaersaagod/tools/request';
import * as Events from '../lib/events';

const MODAL_BODY_CLASS = 'is-modal-open';

export default (el, props) => {
    const dom = $(el);
    const body = $('body');
    const form = dom.find('form');
    const field = dom.find('[data-search-field]');
    const limit = dom.find('[data-limit]');
    const feedback = dom.find('[data-feedback]');
    const results = dom.find('[data-results]');
    const wrapper = dom.find('[data-results-wrapper]');

    let request = null;
    let active = false;
    let lastQuery = '';
    let trigger = false;


    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            Dispatch.emit(Events.SEARCH_CLOSE);
        }
    };

    const cancel = () => {
        if (request) {
            request.abort();
            request = null;
        }
    };

    const clear = () => {
        cancel();
        feedback.empty();
        results.empty();
        wrapper.attr('hidden', '');
    };

    const search = () => {
        clear();
        request = agent.get(`${dom.data('url')}?q=${field.val().trim()}&l=${(limit.val() || '').trim()}`);
        request.then(res => {
            const response = $(res.text);
            feedback.html(response.find('[data-feedback]').html());
            results.html(response.find('[data-results]').html());
            wrapper.attr('hidden', null);
        }, error => {
            console.error(error);
        });
    };

    const keyFieldHandler = () => {
        const query = field.val().trim();
        if (query.length > 2) {
            if (query !== lastQuery) {
                search();
            }
        } else {
            clear();
        }
        lastQuery = query;
    };

    const onOpen = () => {
        if (!active) {
            active = true;
            trigger = document.activeElement;
            document.addEventListener('keyup', keyHandler);
            TweenLite.set(el, { display: 'block', opacity: 0 });
            field.on('keyup', keyFieldHandler).focus();
            body.addClass(MODAL_BODY_CLASS);
            TweenLite.to(el, 0.35, { opacity: 1, ease: Quad.easeInOut });
            Viewport.lockTabbing([el, $('[data-hamburger]').get(0)], field);
        }
    };

    const onClose = () => {
        if (active) {
            active = false;
            document.removeEventListener('keyup', keyHandler);
            body.removeClass(MODAL_BODY_CLASS);
            TweenLite.to(el, 0.15, { opacity: 0, ease: Quad.easeOut, clearProps: 'all' });
            Viewport.releaseTabbing(trigger);
        }
    };

    const onSubmit = () => {
        limit.remove();
    };

    const init = () => {
        form.on('submit', onSubmit);
        Dispatch.on(Events.SEARCH_OPEN, onOpen);
        Dispatch.on(Events.SEARCH_CLOSE, onClose);
    };

    const destroy = () => {
        form.off('submit', onSubmit);
        Dispatch.off(Events.SEARCH_OPEN, onOpen);
        Dispatch.off(Events.SEARCH_CLOSE, onClose);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Search.js